import { useCallback } from "react";
import { NO_COLOR } from "../../../../../constants.js";
import { useColorPicker } from "../../../../../hooks/useColorPicker.js";
function useColorGroup(groupId, colorGroup, maxSwatches) {
  const {
    goToAddColorToPalette,
    onDeleteColor,
    selection,
    onAddColor,
    placeholderMode,
    swatchesPerRow,
    onChange,
    localeText
  } = useColorPicker();
  const canAddColor = !!onAddColor;
  const groupContainsSelection = Array.from(selection).some(
    (color) => color !== NO_COLOR && colorGroup.colors.includes(color)
  );
  const canDeleteColor = !!onDeleteColor && groupContainsSelection;
  const onDeleteSelectedColors = useCallback(() => {
    onDeleteColor?.(Array.from(selection));
  }, [selection, onDeleteColor]);
  const onGoToColorPalette = useCallback(() => {
    goToAddColorToPalette(groupId);
  }, [goToAddColorToPalette, groupId]);
  const lastRowChipsCount = colorGroup.colors.length % swatchesPerRow;
  const addColorDisabled = typeof maxSwatches === "number" ? colorGroup.colors.length >= maxSwatches : false;
  const placeholdersCount = canAddColor && !addColorDisabled ? placeholderMode === "fill-row" ? swatchesPerRow - lastRowChipsCount : 1 : 0;
  return {
    placeholdersCount,
    selection,
    localeText,
    actions: {
      addAction: {
        visible: canAddColor,
        onClick: onGoToColorPalette,
        disabled: addColorDisabled
      },
      deleteAction: {
        visible: canDeleteColor,
        onClick: onDeleteSelectedColors,
        disabled: selection.size === 0
      },
      onChange
    }
  };
}
export {
  useColorGroup
};
//# sourceMappingURL=useColorGroup.js.map
